export enum AgreementStatus {
  NEW = 'NEW',

  ACTIVE = 'ACTIVE',

  INACTIVE = 'INACTIVE',
}
